import React from "react";
import { Col, Row } from "react-bootstrap";
import tggtImg from "../../Assets/experience/tggt.svg";
import gdsc from "../../Assets/experience/gdsc.png";

export default function Experience() {
  return (
    <>
      <div className="d-flex flex-wrap justify-content-around">
        <div className="d-flex flex-wrap align-items-center gap-4">
          <div>
            <img
              src={tggtImg}
              alt="about"
              className="img-fluid"
              style={{ width: "10rem", height: "8rem" }}
            />
          </div>
          <hr
            style={{ height: "7rem", border: "3px solid #c770f0" }}
            className=" rounded opacity-75"
          />
          <div className="d-flex flex-column align-items-start">
            <p className="fs-5">Backend Developer intern</p>
            <div className=" d-flex gap-2">
              <p>at</p>
              <a
                style={{ zIndex: "9999" }}
                className="text-decoration-none text-light"
                href="https://www.thegoodgametheory.com/"
                target={"_blank"}
              >
                thegoodgametheory
              </a>
            </div>
            <p className="fs-5">Nov 2023 - Mar 2024</p>
          </div>
        </div>
        <div className="d-flex flex-wrap align-items-center gap-4">
          <div>
            <img
              src={gdsc}
              alt="gdsc"
              className="img-fluid"
              style={{ width: "8rem", height: "4rem" }}
            />
          </div>
          <hr
            style={{ height: "7rem", border: "3px solid #c770f0" }}
            className=" rounded opacity-75"
          />
          <div className="d-flex flex-column align-items-start">
            <p className="fs-5">Web Core Team Member</p>
            <div className=" d-flex gap-2">
              <p>at</p>
              <a
                style={{ zIndex: "9999" }}
                className="text-decoration-none text-light"
                href="https://gdsccvr.vercel.app/"
                target={"_blank"}
              >
                GDSC - CVR
              </a>
            </div>
            <p className="fs-5">Aug 2023 - Present</p>
          </div>
        </div>
      </div>
    </>
  );
}
